import CodeIcon from '@mui/icons-material/Code';
import FormatBoldIcon from '@mui/icons-material/FormatBold';
import FormatItalicIcon from '@mui/icons-material/FormatItalic';
import FormatStrikethroughIcon from '@mui/icons-material/FormatStrikethrough';
import InsertLinkIcon from '@mui/icons-material/InsertLink';
import { Box, IconButton, Tooltip } from '@mui/material';
import { bool, func, object } from 'prop-types';
import React from 'react';
import { I18n } from 'utils/i18n';

const buttonSx = theme => ({
  padding: theme.spacing(0.5),
  borderRadius: theme.shape.borderRadius,
});

const buttonActiveSx = theme => ({
  backgroundColor: theme.palette.action.selected,
  '&:hover': {
    backgroundColor: theme.palette.action.selected,
  },
});

const FORMATS = [
  { id: 'bold', prefix: '*', suffix: '*', Icon: FormatBoldIcon, labelKey: 'SendForm.Bold' },
  { id: 'italic', prefix: '_', suffix: '_', Icon: FormatItalicIcon, labelKey: 'SendForm.Italic' },
  {
    id: 'strikethrough',
    prefix: '~',
    suffix: '~',
    Icon: FormatStrikethroughIcon,
    labelKey: 'SendForm.Strikethrough',
  },
  { id: 'code', prefix: '`', suffix: '`', Icon: CodeIcon, labelKey: 'SendForm.Monospace' },
];

const FormatToolbar = ({ onWrapSelection, onLinkClick, disabled = false, activeFormats = {} }) => {
  return (
    <Box sx={theme => ({ display: 'flex', alignItems: 'center', gap: theme.spacing(0.5) })}>
      {FORMATS.map(({ id, prefix, suffix, Icon, labelKey }) => (
        <Tooltip key={id} title={I18n.t(labelKey)}>
          <span>
            <IconButton
              size="small"
              sx={activeFormats[id] ? [buttonSx, buttonActiveSx] : buttonSx}
              disabled={disabled}
              color={activeFormats[id] ? 'primary' : 'default'}
              onMouseDown={e => e.preventDefault()}
              onClick={() => onWrapSelection(prefix, suffix)}
              aria-label={I18n.t(labelKey)}
              aria-pressed={!!activeFormats[id]}
            >
              <Icon fontSize="small" />
            </IconButton>
          </span>
        </Tooltip>
      ))}
      <Tooltip title={I18n.t('SendForm.InsertLink')}>
        <span>
          <IconButton
            size="small"
            sx={activeFormats.link ? [buttonSx, buttonActiveSx] : buttonSx}
            disabled={disabled}
            color={activeFormats.link ? 'primary' : 'default'}
            onMouseDown={e => e.preventDefault()}
            onClick={onLinkClick}
            aria-label={I18n.t('SendForm.InsertLink')}
            aria-pressed={!!activeFormats.link}
          >
            <InsertLinkIcon fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>
    </Box>
  );
};

FormatToolbar.propTypes = {
  onWrapSelection: func.isRequired,
  onLinkClick: func.isRequired,
  disabled: bool,
  activeFormats: object,
};

export default FormatToolbar;
